import * as AgrupacionesTorneos from '../constantes/AgrupacionesTorneos.js';
import * as Localia from '../constantes/Localia.js';
import * as TipoEquipo from '../constantes/TipoEquipo.js';
import * as TipoRival from '../constantes/TipoRival.js';
import { ListaPartidos } from '../constantes/Filtros.js';

export const TiposRival = [
  { id: TipoRival.CLUB, descripcion: 'Club' },
  { id: TipoRival.EQUIPO, descripcion: 'Equipo' },
  { id: TipoRival.SELECCION, descripcion: 'Selección' },
];

export const ArmarRival = (tipo, totales, objeto, categoria, tipoInternacional) => {
  return {
    tipo: tipo,
    totales: totales,
    objeto: objeto,
    categoria: categoria,
    tipoInternacional: tipoInternacional,
  };
};

export const RivalVacio = () => ArmarRival(null, null, null, null, null);

export const EncontrarRival = (idTipo) => {
  return TiposRival.find((item) => item.id === idTipo);
};

export const TipoRivalInicial = (tipoHistorial) => {
  switch (tipoHistorial) {
    case TipoEquipo.CLUB:
      return EncontrarRival(TipoRival.CLUB);
    case TipoEquipo.SELECCION:
      return EncontrarRival(TipoRival.SELECCION);
    default:
      return null;
  }
};

export const GetCondicion = (partido) =>
  partido.neutral ? Localia.NEUTRAL : partido.localia || '-';

export const getFiltroPartidos = (tipoHistorial, tipoRival) => {
  switch (tipoHistorial) {
    case TipoEquipo.CLUB:
      return getFiltroPartidosClub(tipoRival);
    case TipoEquipo.SELECCION:
      return getFiltroPartidosSeleccion(tipoRival);
    default:
      return [];
  }
};

export const getFiltroPartidosClub = (tipoRival) => {
  if (tipoRival === TipoRival.CLUB) {
    return [
      { codigo: ListaPartidos.TOTALES, descripcion: 'Totales' },
      { codigo: AgrupacionesTorneos.LIGAS_NACIONALES, descripcion: 'Liga Nacional' },
      { codigo: AgrupacionesTorneos.COPAS_NACIONALES, descripcion: 'Copas Nacionales' },
      { codigo: AgrupacionesTorneos.INTERNACIONALES, descripcion: 'Internacionales' },
      { codigo: ListaPartidos.AMISTOSOS, descripcion: 'Amistosos' },
    ];
  } else {
    return [];
  }
};

export const getFiltroPartidosSeleccion = (tipoRival) => {
  if (tipoRival === TipoRival.SELECCION) {
    return [
      { codigo: ListaPartidos.TOTALES, descripcion: 'Totales' },
      { codigo: ListaPartidos.OFICIALES, descripcion: 'Oficiales' },
      { codigo: ListaPartidos.NO_OFICIALES, descripcion: 'Amistosos' },
    ];
  } else {
    return [];
  }
};
